import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sword-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4e4946b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-card" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icon"
}, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'ResultCard',
  props: {
    id: {},
    name: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.name), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.description), 1),
    _hoisted_3
  ]))
}
}

})